import { useAuth } from './useAuth'

/**
 * Hook that reads customPermissions from JWT and returns advisor menu permission flags.
 * Returns true for all flags when not advisor-impersonating (so donors/admins are unaffected).
 */
export function useAdvisorPermissions() {
  const [{ impersonationType, customPermissions }] = useAuth()

  const isAdvisorImpersonating = impersonationType === 'ADVISOR'

  // When not advisor-impersonating, all permissions are granted
  if (!isAdvisorImpersonating || !customPermissions) {
    return {
      isAdvisorImpersonating,
      menuGivingActivity: true,
      menuInvestmentActivity: true,
      menuContribute: true,
      menuDocuments: true,
      menuGrants: true,
    }
  }

  return {
    isAdvisorImpersonating,
    menuGivingActivity: customPermissions.menuGivingActivity !== false,
    menuInvestmentActivity: customPermissions.menuInvestmentActivity !== false,
    menuContribute: customPermissions.menuContribute !== false,
    menuDocuments: customPermissions.menuDocuments !== false,
    menuGrants: customPermissions.menuGrants === true,
  }
}
